export default __webpack_public_path__ + "static/media/logo.74f4f218.svg";